import { Component, OnInit, ChangeDetectionStrategy, ViewEncapsulation, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { Select } from '@ngxs/store';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { Observable, Subject, combineLatest } from 'rxjs';
import { ViewService } from '../../view.service';
import { LayoutService } from '../../layout.service';
import { ViewLayout } from '../../models/view-layout.enum';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-view-scene-pagination',
  templateUrl: './view-scene-pagination.component.html',
  styleUrls: ['./view-scene-pagination.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class ViewScenePaginationComponent implements OnInit, OnDestroy {
  // ---------- Observables ----------
  @Select(StoryChaptersState.getSelectedChapterIndex)
  chapterIndex$: Observable<number>;

  @Select(StoryChaptersState.getChapterCount)
  chapterCount$: Observable<number>;
  
  
  // ---------- Class Variables ----------
  viewLayout = ViewLayout;
  nextChapterLabel = '';
  previousChapterLabel = '';
  ngUnsubscribe = new Subject();
  
  // ---------- Lifecycle Events ----------
  constructor(
    private viewService: ViewService,
    private layoutService: LayoutService,
    private changeDetectorRef: ChangeDetectorRef
  ) { }

  ngOnInit() {
    combineLatest(
      this.chapterIndex$,
      this.chapterCount$
    ).pipe(
      takeUntil(this.ngUnsubscribe)
    ).subscribe(([index, count]) => {
      const previous = index > 0 ? index : 1;
      const next = index + 2 > count ? count : index + 2;

      this.nextChapterLabel = `Next Chapter (${next} of ${count})`;
      this.previousChapterLabel = `Previous Chapter (${previous} of ${count})`;
      this.changeDetectorRef.markForCheck();
    });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }


  isEnabled(layout: ViewLayout) {
    return this.layoutService.isLayoutEnabled(layout);
  }

  // ---------- Interactions ----------
  handleNextChapter() {
    this.viewService.nextChapter();
  }

  handlePreviousChapter() {
    this.viewService.previousChapter();
  }
}
